import { ProfileInfoEntry, useProfileCustomValues } from "PFApp/hooks/use_profile_custom_values";
import { Profile } from "PFTypes";

type UseReassignCustomInfo = {
  profile: Partial<Profile> & Pick<Profile, "positions">;
};

export const useReassignCustomInfo = ({ profile }: UseReassignCustomInfo): ProfileInfoEntry | null => {
  const { getCustomType, getCustomValue } = useProfileCustomValues();
  const customType = getCustomType("match_info_1");

  if (!customType) {
    return null;
  }

  return {
    customType,
    value: getCustomValue(profile, "match_info_1")?.value ?? ""
  };
};
